import { FC, SVGAttributes } from "react";

const Check: FC<SVGAttributes<SVGSVGElement>> = ({
  height = "12px",
  width = "12px",
  fill = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M20 6L9 17L4 12"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { Check };
